import { memoize } from 'lodash-es';

import logger from 'utils/logger';

const importMap = {
  en_US: () => import('state/translations/en.json'),
  en_CA: () => import('state/translations/en_CA.json'),
  en: () => import('state/translations/en.json'),
  fr_CA: () => import('state/translations/fr.json'),
  fr: () => import('state/translations/fr.json'),
};

export const getMessagesForLanguage = memoize(async (language: string, region: string) => {
  let regionLocale;
  let baseLocale;

  try {
    regionLocale = await importMap[`${language}_${region}`]();
  } catch (e) {
    logger.warn(e);
  }

  try {
    baseLocale = await importMap[language]();
  } catch (e) {
    logger.warn(e);
  }
  return { ...(baseLocale || {}), ...(regionLocale || {}) } as Record<string, string>;
});
